"use strict";
// Goal of this file is to inject all necessary device/signer dependency to coin-modules
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolver = exports.cliTools = exports.bridge = void 0;
const js_1 = require("@ledgerhq/coin-evm/bridge/js");
const cli_transaction_1 = __importDefault(require("@ledgerhq/coin-evm/cli-transaction"));
const hw_getAddress_1 = __importDefault(require("@ledgerhq/coin-evm/hw-getAddress"));
const hw_app_eth_1 = __importDefault(require("@ledgerhq/hw-app-eth"));
const setup_1 = require("../../bridge/setup");
const createSigner = (transport) => {
    return new hw_app_eth_1.default(transport);
};
const bridge = (0, js_1.createBridges)((0, setup_1.executeWithSigner)(createSigner));
exports.bridge = bridge;
const resolver = (0, setup_1.createResolver)(createSigner, hw_getAddress_1.default);
exports.resolver = resolver;
const cliTools = (0, cli_transaction_1.default)();
exports.cliTools = cliTools;
//# sourceMappingURL=setup.js.map